export const extractLayoutFromContent = data => {
  const { layout } = data

  if (!layout) {
    const { layoutName, brand, Brand } = data
    if (layoutName && (brand || Brand)) {
      data.layout = { layoutName, brand: brand || Brand }
      return data.layout
    }
  }

  return layout
}
